import UserManagementScreen from '@screens/UserManagement/UserManagementScreen';

export default UserManagementScreen;
